/**
 * The icon of a navigation entry: either a fixed icon or a function that is evaluated whenever the
 * navigation renders, for an icon that follows application state - see `inboxNavigationIcon`.
 */
export type NavigationIcon = string | (() => string);

/**
 * Resolves the configured icon of a navigation entry to the icon to render.
 *
 * Called from the render of the navigation components, so that a dynamic icon re-evaluates - and
 * with it re-renders - whenever the state it reads changes.
 *
 * @param icon the icon configured on the navigation entry
 */
export function resolveNavigationIcon(icon?: NavigationIcon): string | undefined {
  return typeof icon === "function" ? icon() : icon;
}
